/**
 * interruptedSlice — Jan 2026 retry UI for WS-disconnect-mid-query.
 *
 * If the WS drops while the agent is still streaming, v1 stores the
 * original envelope (query + config) so the user can hit "Retry" without
 * retyping. The dismiss/retry actions live in hooks; this slice only
 * holds the state + the two setters.
 */

import type { StateCreator } from "zustand";
import type { InterruptedQuery } from "./types";
import type { ChatStore } from "./chatStore";

export interface InterruptedSlice {
  interrupted: InterruptedQuery | null;

  setInterruptedQuery: (q: InterruptedQuery | null) => void;
  clearInterruptedQuery: () => void;
}

export const createInterruptedSlice: StateCreator<
  ChatStore,
  [],
  [],
  InterruptedSlice
> = (set) => ({
  interrupted: null,

  setInterruptedQuery: (q) => set({ interrupted: q }),
  clearInterruptedQuery: () => set({ interrupted: null }),
});
